export const FEATURE_FLAGS = 'X-Feature-Flags';
